module.exports = __webpack_public_path__ + "d443c086950534cd2a77a057c628265e.svg";